function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_79433",
  "data-name": "Group 79433",
  transform: "translate(-116.857 -644.857)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Union_223",
  "data-name": "Union 223",
  d: "M-10921.826-19111.889a4,4,0,0,1,0-5.656l8-8a3.994,3.994,0,0,1,5.655,0,3.993,3.993,0,0,1,0,5.654l-8,8a3.971,3.971,0,0,1-2.83,1.174A3.969,3.969,0,0,1-10921.826-19111.889Zm58.284,0-8-8a3.971,3.971,0,0,1-1.174-2.824,3.975,3.975,0,0,1,1.174-2.83,3.994,3.994,0,0,1,5.655,0l8,8a4,4,0,0,1,0,5.656,3.984,3.984,0,0,1-2.827,1.174A3.984,3.984,0,0,1-10863.542-19111.889Zm-8-50.285a3.993,3.993,0,0,1,0-5.654l8-8a3.994,3.994,0,0,1,5.655,0,3.993,3.993,0,0,1,0,5.654l-8,8a3.971,3.971,0,0,1-2.83,1.174A3.968,3.968,0,0,1-10871.541-19162.174Zm-42.286,0-8-8A3.971,3.971,0,0,1-10923-19173a3.975,3.975,0,0,1,1.174-2.83,3.994,3.994,0,0,1,5.655,0l8,8a3.993,3.993,0,0,1,0,5.654A3.984,3.984,0,0,1-10911-19161,3.986,3.986,0,0,1-10913.827-19162.174Z",
  transform: "translate(11039.857 19821.859)",
  fill: "#fcfcfc",
  opacity: 0.24
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_150345",
  "data-name": "Path 150345",
  d: "M50.733,16.866a3.682,3.682,0,0,0-7.182,0l-3.4,14.961a11.048,11.048,0,0,1-8.323,8.323l-14.961,3.4a3.682,3.682,0,0,0,0,7.182l14.961,3.4a11.048,11.048,0,0,1,8.323,8.323l3.4,14.961a3.682,3.682,0,0,0,7.182,0l3.4-14.961a11.048,11.048,0,0,1,8.323-8.323l14.961-3.4a3.682,3.682,0,0,0,0-7.182l-14.961-3.4a11.048,11.048,0,0,1-8.323-8.323Z",
  transform: "translate(102.857 630.857)",
  fill: "#fff",
  fillRule: "evenodd"
}));

function SvgPerfectAi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.287 66.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfectAi);
export default __webpack_public_path__ + "static/media/perfect-ai.7f2389d9.svg";
export { ForwardRef as ReactComponent };